"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"
import { Loader2 } from "lucide-react"
import { useOrg } from "@/components/employer/org-context"

export default function EmployerIndex() {
  const router = useRouter()
  const { loading, activeOrg } = useOrg()

  useEffect(() => {
    if (loading) return
    router.replace(activeOrg ? "/employer/dashboard" : "/employer/onboarding")
  }, [loading, activeOrg, router])

  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  )
}
